import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import AuthShellLayout from 'components/shared/AuthShell/AuthShellLayout';

const PasswordReset = withLazyFallback(() => import('components/Auth'));
const PasswordRequest = withLazyFallback(() => import('components/Auth/request'));
const PasswordSet = withLazyFallback(() => import('components/Auth/set'));
const Login = withLazyFallback(() => import('components/admin/components/Login/Login'));
const NotFound = withLazyFallback(() => import('components/NotFound'));
const AdminPasswordReset = withLazyFallback(() => import('components/admin/pages/ResetPassword'));
const AdminPasswordRequest = withLazyFallback(
  () => import('components/admin/pages/ResetPassword/request')
);
const AdminPasswordSet = withLazyFallback(() => import('components/admin/pages/ResetPassword/set'));
const Logout = withLazyFallback(() => import('components/shared/Logout/Logout'));

// The pathless AuthShellLayout routes keep one shell (background + card)
// mounted across login and password screens so navigating between them only
// swaps the card content — no full-screen remount/flash.
const AUTHENTICATION = [
  {
    element: <AuthShellLayout theme="light" />,
    children: [
      {
        path: 'login',
        element: <Login loginType="user" />,
        handle: { title: 'Login' }
      },
      {
        path: 'password/*',
        element: <PasswordReset />,
        children: [
          { path: 'request', element: <PasswordRequest />, handle: { title: 'Password reset' } },
          { path: 'reset/:token', element: <PasswordSet />, handle: { title: 'Set new password' } },
          { path: '*', element: <NotFound portal="password/request" /> }
        ]
      }
    ]
  },
  {
    element: <AuthShellLayout theme="dark" />,
    children: [
      {
        path: 'admin/login',
        element: <Login />,
        handle: { title: 'Login' }
      },
      {
        path: 'admin/password/*',
        element: <AdminPasswordReset />,
        children: [
          {
            path: 'request',
            element: <AdminPasswordRequest />,
            handle: { title: 'Password reset' }
          },
          {
            path: 'reset/:token',
            element: <AdminPasswordSet />,
            handle: { title: 'Set new password' }
          },
          { path: '*', element: <NotFound portal="admin" isDark /> }
        ]
      }
    ]
  },
  {
    path: 'logout',
    element: <Logout />
  }
];

export default AUTHENTICATION;
